import React from "react";
import { v4 as uuidv4 } from "uuid"; // Import UUID library

const ScheduleDisplay = ({ schedules }) => {
  return (
    <div className="schedule-list mb-0">
      <ul>
        {schedules.map((item) => (
          <li className={item.active ? "active" : ""} key={uuidv4()}>
            {item.label}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default ScheduleDisplay;
